import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=b173a85c&"
import script from "./OptionGroup.vue?vue&type=script&lang=js&"
export * from "./OptionGroup.vue?vue&type=script&lang=js&"
import style0 from "./OptionGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports